import { SupportedLocale } from "@/types/SupportedLocale";

export const RTL_LANGUAGES = ["ar", "fa", "he", "kd", "pk", "ps", "ug", "ur", "yi"] as const;
export const isRtlLocale = (locale: SupportedLocale) =>
  !!RTL_LANGUAGES.find((lang) => locale.startsWith(lang));
